GatorSurvey.app = angular.module('GatorSurvey', ['ui.router', 'ngSanitize', 'ghTemplateSelect', 'bootstrapDateTimePicker', 'dndLists', 'ngMaterial', 'mdColorPicker']);

GatorSurvey.app.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$httpProvider', '$mdThemingProvider',
    function ($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $mdThemingProvider, palettes) {
  
    $urlRouterProvider.otherwise("/");
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });

    $stateProvider
        .state("blank",
        {
            url: "/",
            templateUrl:  "Assets/Templates/surveying.html"
        })
        .state("survey",
            {
                url: "/{userId}",
                templateUrl:  "Assets/Templates/surveying.html"
            }
        )
        .state("surveyReview",
            {
                url: "/Review/{userId}",
                templateUrl:  "Assets/Templates/review.html"
                }
            )
        ;
    }]);

getUrlParameter = function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};